type ImpressionKey = string

const cachedImpressionKeys: ImpressionKey[] = []

const getCachedImpressionKeys = () => cachedImpressionKeys
const addCachedImpression = (impressionString: ImpressionKey) =>
  cachedImpressionKeys.push(impressionString)

export { getCachedImpressionKeys, addCachedImpression }
